import React, { Component, useState, useEffect } from "react";
import ReactModal from "react-modal";
import * as d3 from "d3";
import { Link } from "react-router-dom";
import ReactTooltip from "../ReactTooltip.js";
const RoadmapCard = ({ props, roadmapViewMode, setIsOpen }) => {
  const { roadmapDataHistory, customThumbnail, _id, percentage } = props;
  var editionIndex;
  if (roadmapViewMode === "starred") {
    editionIndex = props.editionIndex;
  } else {
    editionIndex = roadmapDataHistory.length - 1;
  }

  const { title, description, backgroundColor } = roadmapDataHistory[
    editionIndex
  ];
  const pushToLink =
    roadmapViewMode === "starred" ? `/roadmap/${_id}` : `/create/${_id}`;
  var color = d3.scaleLinear().domain([0, 100]).range(["grey", "green"]);
  var tooltipContent;
  switch (roadmapViewMode) {
    case "starred":
      tooltipContent = (
        <div className="ReactTooltip">
          <div className="ReactTooltipColumn">Untrack</div>
          <div
            className="ReactTooltipColumn set"
            onClick={() => {
              openModal();
              console.log(props);
            }}
          >
            Add to Set
          </div>
        </div>
      );
      break;
    case "created":
      tooltipContent = (
        <div className="ReactTooltip">
          <div className="ReactTooltipColumn">Delete</div>
          <div className="ReactTooltipColumn set"></div>
        </div>
      );

      break;
    case "drafted":
      tooltipContent = (
        <div className="ReactTooltip">
          <div className="ReactTooltipColumn">Delete</div>
        </div>
      );
      break;
  }

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <React.Fragment>
      <div className="roadmapContainer">
        <img
          src={"https://roadmapedia.s3.amazonaws.com/" + customThumbnail.url}
          className="roadmapImg"
          style={{
            backgroundColor:
              customThumbnail.type === "default" ? backgroundColor : null,
          }}
        />
        <div className="metaContainer">
          <div className="metaContainer-inner">
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to={{ pathname: pushToLink, state: { mode: "draft" } }}
            >
              <div className="roadmapTitle">
                <div>{title}</div>
              </div>
            </Link>
            {roadmapViewMode === "starred" && (
              <div
                className="roadmapProgress"
                style={{ color: color(percentage) }}
              >
                {percentage}% Completed
              </div>
            )}
          </div>

          <ReactTooltip position="bottom">{tooltipContent}</ReactTooltip>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RoadmapCard;
